export default __webpack_public_path__ + "static/media/IMG3392.5b6b8ae6.jpg";